import { itemHasContent } from '../../utils/helpers';

const sustainabilityFields = ['problem', 'value', 'sdg'];

export default function calculateSustainabilityProgress(
  rootState,
  minRequired = 1,
) {
  let filledCount = 0;
  let totalCollectionItems = 0;

  if (rootState.sustainability.collection.length) {
    rootState.sustainability.collection.forEach((item) => {
      let foundUnfilledField = false;
      sustainabilityFields.forEach((field) => {
        if (!itemHasContent(item, [field])) {
          foundUnfilledField = true;
        }
      });
      if (!foundUnfilledField) filledCount += 1;
    });
  }
  totalCollectionItems += rootState.sustainability.collection.length;

  if (filledCount === 0) return 0;
  const denominator = Math.max(minRequired, totalCollectionItems);
  const sectionProgress = Math.round((filledCount / denominator) * 100);
  return sectionProgress;
}
